// covered-by: frontends/carrie/src/routes/ask-puntt/__tests__/chatSearch.test.ts
//
// Single source of truth for standalone ask-puntt chat search params.
//
// URL contract for /ask-puntt/:chatId:
//   ?review=<ticketId>  — open review pane / multi-review workspace
//   ?version=<n>        — optional version pin when review is open
//   ?canvas=<messageId> — focus a canvas block (Phase 4)

export type ChatSearch = {
  review?: string;
  version?: number;
  canvas?: string;
};

export type ChatSearchInput = Partial<ChatSearch>;

/** Raw search record from TanStack validateSearch. */
export function parseChatSearch(search: Record<string, unknown>): ChatSearch {
  const reviewRaw = typeof search.review === "string" ? search.review : "";
  const review = reviewRaw.trim().length > 0 ? reviewRaw.trim() : undefined;

  const canvasRaw = typeof search.canvas === "string" ? search.canvas : "";
  const canvas = canvasRaw.trim().length > 0 ? canvasRaw.trim() : undefined;

  let version: number | undefined;
  if (search.version != null && search.version !== "") {
    const parsed = Number(search.version);
    if (!Number.isNaN(parsed) && parsed >= 0) {
      version = parsed;
    }
  }

  return {
    review,
    canvas,
    version: review != null && version != null ? version : undefined,
  };
}

/** Search params for `askPunttChatRoute` navigations. */
export function chatSearch(input?: ChatSearchInput): ChatSearch {
  const raw = input ?? {};
  const review = raw.review?.trim() ? raw.review.trim() : undefined;
  const canvas = raw.canvas?.trim() ? raw.canvas.trim() : undefined;
  const version =
    raw.version != null && raw.version >= 0 ? raw.version : undefined;

  return {
    review,
    canvas,
    version: review != null && version != null ? version : undefined,
  };
}
